var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-text-field", {
    staticClass: "searchList mx-1",
    attrs: {
      "prepend-inner-icon": "mdi-magnify",
      label: "Pesquisa rápida",
      clearable: "",
      "single-linehide-details": "",
      "hide-details": "",
    },
    on: {
      change: function ($event) {
        return _vm.Mudou()
      },
    },
    model: {
      value: _vm.localSearch,
      callback: function ($$v) {
        _vm.localSearch = $$v
      },
      expression: "localSearch",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }